/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Browser_DescriptionInputs */

const en_zotero_browser_description = /** @type {(inputs: Zotero_Browser_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select items from your Zotero library to convert to audio.`)
};

const es_zotero_browser_description = /** @type {(inputs: Zotero_Browser_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona elementos de tu biblioteca de Zotero para convertirlos en audio.`)
};

/**
* | output |
* | --- |
* | "Select items from your Zotero library to convert to audio." |
*
* @param {Zotero_Browser_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_browser_description = /** @type {((inputs?: Zotero_Browser_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Browser_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_browser_description(inputs)
	return en_zotero_browser_description(inputs)
});